import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  loaded: function loaded(state) {
    return state.loaded;
  },
  user: function user(state) {
    return Boolean(state.customer.user) && _objectSpread({}, state.customer.user, {
      user_type: state.customer.user_type,
      date_first_visit: state.customer.date_first_visit
    });
  },
  isConnected: function isConnected(state) {
    return Boolean(state.customer.user);
  },
  cart: function cart(state) {
    return state.customer.cart;
  },
  cartItems: function cartItems(state) {
    return state.customer.cartItems;
  },
  cartSuccess: function cartSuccess(state) {
    return state.customer.cartSuccess;
  }
};